<div class="container mt-3">
  <div *ngIf="authService.userInfo" class="row text-center">
    <div class="col">
      <h1 class="text-center">Benvenuto {{ authService.userInfo.name }}</h1>
    </div>
  </div>

  <ng-container *ngIf="vm$ | async as vm">
    <div *ngIf="aslDetails" class="alert alert-info mt-2" role="alert">
      <p><strong>ASL:</strong> {{ aslDetails.code }} — {{ aslDetails.name }}</p>
      <ng-container *ngFor="let key of vm.visibleKeys">
        <p *ngIf="vm.state[key].selected"><strong>{{ vm.state[key].label }} selezionato:</strong> {{
          vm.state[key].selected?.name }}</p>
      </ng-container>
    </div>

    <div class="row my-3">
      <div class="col-auto">
        <it-callout [appearance]="'highlight'" [color]="'important'" [label]="'Cambio contesto'">
          <p>{{ message }}</p>
        </it-callout>
      </div>
    </div>

    <it-tab-container auto="true" [cards]="'true'" *ngIf="vm.visibleKeys.length > 0; else noData">
      <ng-container *ngFor="let key of vm.visibleKeys; let i = index">
        <it-tab-item [label]="vm.state[key].label" [active]="i === 0">
          <it-list>
            <it-list-item *ngFor="let item of vm.state[key].items" (click)="onSelect(key, item)">
              <div class="d-flex align-items-center justify-content-between clickable-row">
                <span class="fw-medium">{{ item.name }}</span>
                <it-icon name="chevron-right" color="primary"></it-icon>
              </div>
            </it-list-item>
          </it-list>
        </it-tab-item>
      </ng-container>
    </it-tab-container>

    <ng-template #noData>
      <div class="alert alert-warning mt-2" role="alert">
        Nessuna struttura disponibile per il tuo profilo.
      </div>
    </ng-template>
  </ng-container>
</div>